import React from "react";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import { Box, Typography } from "@mui/material";

/**
 * 共通の案内バナー
 */
export default function NoticeBanner({ text }) {
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        gap: 1,
        borderRadius: "999px",

        width: { xs: "100%", sm: "auto" },
        justifyContent: "flex-start",
        minHeight: { xs: 32, sm: 22 },
        pl: { xs: "4px", sm: "4px" },
        pr: { xs: "6px", sm: "4px" },
        py: { xs: "3px", sm: "1.5px" },

        bgcolor: "#FFFFFF",
        color: "#666",

        // 吹き出し
        "&::after": {
          content: '""',
          position: "absolute",

          // スマホ：上中央
          top: { xs: -5, sm: "50%" },
          left: { xs: "50%", sm: "auto" },
          right: { xs: "auto", sm: -3 },
          transform: {
            xs: "translateX(-50%)",
            sm: "translateY(-50%)",
          },

          width: 0,
          height: 0,

          // スマホ：上向き,PC：右向き
          borderTop: {
            xs: "none",
            sm: "4px solid transparent",
          },
          borderRight: {
            xs: "6px solid transparent",
            sm: "none",
          },
          borderBottom: {
            xs: "6px solid #FFFFFF",
            sm: "4px solid transparent",
          },
          borderLeft: {
            xs: "6px solid transparent",
            sm: "4px solid #FFFFFF",
          },
        },
      }}
    >
      {/* 黄色アイコン */}
      <Box
        sx={{
          width: { xs: 28, sm: 16 },
          height: { xs: 28, sm: 16 },
          borderRadius: "50%",
          bgcolor: "#FFD400",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <PriorityHighIcon
          sx={{
            color: "#000",
            fontSize: { xs: 16, sm: 12 },
            fontWeight: "bold",
          }}
        />
      </Box>

      <Typography
        sx={{
          flex: 1,
          textAlign: "center",
          fontSize: { xs: "0.7rem", sm: "0.6rem" },
          lineHeight: 1.2,
          whiteSpace: "nowrap",
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
